module.exports = __webpack_public_path__ + "static/media/27OCHA10.061193dc.jpg";